import styled from 'styled-components'
import DatePicker from '../../../../../generic/ui/DatePicker/DatePicker'
import { SearchInput } from '../../../../../generic/ui/SearchInput/SearchInput'
import KbdChipButton from '../../../../../generic/ui/KbdChipButton/KbdChipButton'
import PrintIcon from '../../../../../generic/icons/IconLib/PrintIcon'
import StarIcon from '../../../../../generic/icons/IconLib/StarIcon'
import TruckIcon from '../../../../../generic/icons/IconLib/TruckIcon'
import SellerFilterButton from './SellerFilterButton'
import { IClientsItem } from '../../../../../modules/API/Defaults/models/customers'
import { IGrowerItem } from '../../../../../modules/API/Defaults/models/growers'

type Props = {
  input: string
  setInput: (value: string) => void
  date: Date
  setDate: (date: Date) => void
  isCustomer?: boolean
  onPrint: () => void
  onOpenFavorites: () => void
  onOpenTransportation: () => void
  customerList: IClientsItem[]
  growerList: IGrowerItem[]
  selectedCustomer: number
  setSelectedCustomer: (id: number) => void
  selectedGrower: number
  setSelectedGrower: (id: number) => void
}

const SellerToolbar = ({
  input,
  setInput,
  date,
  setDate,
  isCustomer,
  onPrint,
  onOpenFavorites,
  onOpenTransportation,
  customerList,
  growerList,
  selectedCustomer,
  setSelectedCustomer,
  selectedGrower,
  setSelectedGrower,
}: Props) => {
  return (
    <Actions>
      <Fields>
        <ToolbarDate
          selected={date}
          setDate={() => {}}
          onChange={(nextDate) => nextDate && setDate(nextDate)}
        />
        <Search
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="חיפוש פריט"
          showKbd={false}
        />
      </Fields>
      <Buttons>
        <IconChip type="button" onClick={onPrint} aria-label="הדפסת דוח לקוח" title="הדפסת דוח לקוח">
          <PrintIcon />
        </IconChip>
        {!isCustomer && (
          <>
            
            <IconChip type="button" onClick={onOpenFavorites} aria-label="מועדפים" title="מועדפים">
              <StarIcon />
            </IconChip>
            <IconChip type="button" onClick={onOpenTransportation} aria-label="משלוחים" title="משלוחים">
              <TruckIcon />
            </IconChip>
            <SellerFilterButton
              customerList={customerList}
              growerList={growerList}
              selectedCustomer={selectedCustomer}
              setSelectedCustomer={setSelectedCustomer}
              selectedGrower={selectedGrower}
              setSelectedGrower={setSelectedGrower}
            />
          </>
        )}
      </Buttons>
    </Actions>
  )
}

export default SellerToolbar

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;

  /* Mobile: stack into two rows — fields on top, action buttons below. */
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
    width: 100%;
  }
`

const Fields = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 100%;
  }
`

const Buttons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  & > button {
    flex-shrink: 0;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 100%;
    justify-content: flex-end;
  }
`

const ToolbarDate = styled(DatePicker)`
  && {
    height: 2.5rem;
  }
`

const Search = styled(SearchInput)`
  width: 14rem;
  min-height: 2.5rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: auto;
    flex: 1;
  }
`

const IconChip = styled(KbdChipButton)`
  width: 2.5rem;
  min-width: 2.5rem;
  height: 2.5rem;
  padding: 0;
`
